module.exports = __webpack_public_path__ + "img/brazil.1643c702.svg";